import type { Currency } from "@anaconda/core/price/types"
import { CurrencyFilter } from "./currency-filter"
import { PriceRangeFilter } from "./price-range-filter"

interface Props {
  currency: Currency
}

export function PriceFilter({ currency }: Props) {
  return (
    <div className="flex flex-col gap-4">
      <CurrencyFilter currency={currency} />
      <PriceRangeFilter />
    </div>
  )
}
